"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApiVersions = exports.EnvNameEnum = exports.BasicBrandToBrandCode = exports.BrandCodeToBasicBrand = exports.BasicBrandEnum = exports.BrandCodeEnum = exports.MMEnvironmentVariables = exports.MMHeaders = exports.MeaningEnum = exports.ContextEnum = exports.LanguageEnum = exports.MarketEnum = exports.ModuleEnum = exports.DimensionEnum = void 0;
var DimensionEnum;
(function (DimensionEnum) {
    DimensionEnum["MODULE"] = "module";
    DimensionEnum["VERSION"] = "version";
    DimensionEnum["MARKET"] = "market";
    DimensionEnum["LANGUAGE"] = "language";
    DimensionEnum["BRAND_CODE"] = "brandCode";
    DimensionEnum["BRAND"] = "brand";
    DimensionEnum["ENV_NAME"] = "envName";
    DimensionEnum["CONTEXT"] = "context";
    DimensionEnum["MEANING"] = "meaning";
})(DimensionEnum = exports.DimensionEnum || (exports.DimensionEnum = {}));
var ModuleEnum;
(function (ModuleEnum) {
    ModuleEnum["SPC_API"] = "spc-api";
    ModuleEnum["DIGITAL_API"] = "digital-api";
    ModuleEnum["SSM"] = "ssm";
    ModuleEnum["FC"] = "fc";
    ModuleEnum["PX"] = "px";
    ModuleEnum["DEALER"] = "dealer";
    ModuleEnum["DEAL"] = "deal";
    ModuleEnum["BO_API"] = "bo-api";
    ModuleEnum["DIGITAL"] = "digital";
    ModuleEnum["STATIC"] = "files";
    ModuleEnum["EMAIL"] = "email";
    ModuleEnum["CAMPAIGN_BUILDER"] = "campaign-builder";
    ModuleEnum["CUSTOMER_JOURNEY"] = "cj";
    ModuleEnum["LEADTIME"] = "leadtime";
    ModuleEnum["CONTENT_MANAGER"] = "content-manager";
    ModuleEnum["RETAIL_FRONTEND"] = "retail-frontend";
    ModuleEnum["NEOLANE_ADAPTER"] = "neolane-adapter";
})(ModuleEnum = exports.ModuleEnum || (exports.ModuleEnum = {}));
var MarketEnum;
(function (MarketEnum) {
    MarketEnum["FR"] = "fr";
    MarketEnum["GB"] = "gb";
    MarketEnum["DE"] = "de";
    MarketEnum["IT"] = "it";
    MarketEnum["ES"] = "es";
})(MarketEnum = exports.MarketEnum || (exports.MarketEnum = {}));
var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum["FR"] = "fr";
    LanguageEnum["EN"] = "en";
    LanguageEnum["DE"] = "de";
    LanguageEnum["IT"] = "it";
    LanguageEnum["ES"] = "es";
})(LanguageEnum = exports.LanguageEnum || (exports.LanguageEnum = {}));
var ContextEnum;
(function (ContextEnum) {
    ContextEnum["DEFAULT"] = "default";
    ContextEnum["EC41_B2B"] = "ec41_b2b";
})(ContextEnum = exports.ContextEnum || (exports.ContextEnum = {}));
var MeaningEnum;
(function (MeaningEnum) {
    MeaningEnum["FRONTEND"] = "frontend";
    MeaningEnum["BACKEND"] = "backend";
})(MeaningEnum = exports.MeaningEnum || (exports.MeaningEnum = {}));
var MMHeaders;
(function (MMHeaders) {
    MMHeaders["BRAND_CODE"] = "x-brand-code";
    MMHeaders["MARKET"] = "x-market";
    MMHeaders["LANGUAGE"] = "x-language";
    MMHeaders["DIMENSIONS_KEY"] = "x-dimensions-key";
    MMHeaders["ENV_NAME"] = "x-env-name";
    MMHeaders["CONTEXT"] = "x-context";
    MMHeaders["FEATURE_SWITCHER"] = "x-feature";
    MMHeaders["API_VERSION"] = "x-api-version";
})(MMHeaders = exports.MMHeaders || (exports.MMHeaders = {}));
var MMEnvironmentVariables;
(function (MMEnvironmentVariables) {
    MMEnvironmentVariables["BRAND_CODE"] = "X_BRAND_CODE";
    MMEnvironmentVariables["MARKET"] = "X_MARKET";
    MMEnvironmentVariables["LANGUAGE"] = "X_LANGUAGE";
    MMEnvironmentVariables["DIMENSIONS_KEY"] = "X_DIMENSIONS_KEY";
    MMEnvironmentVariables["ENV_NAME"] = "X_ENV_NAME";
    MMEnvironmentVariables["CONTEXT"] = "X_CONTEXT";
    MMEnvironmentVariables["API_VERSION"] = "X_API_VERSION";
})(MMEnvironmentVariables = exports.MMEnvironmentVariables || (exports.MMEnvironmentVariables = {}));
var BrandCodeEnum;
(function (BrandCodeEnum) {
    BrandCodeEnum["PEUGEOT"] = "AP";
    BrandCodeEnum["CITROEN"] = "AC";
    BrandCodeEnum["DS"] = "DS";
    BrandCodeEnum["DSAUTOMOBILES"] = "DS";
    BrandCodeEnum["VAUXHALL"] = "OV";
    BrandCodeEnum["OPEL"] = "OV";
})(BrandCodeEnum = exports.BrandCodeEnum || (exports.BrandCodeEnum = {}));
var BasicBrandEnum;
(function (BasicBrandEnum) {
    BasicBrandEnum["PEUGEOT"] = "peugeot";
    BasicBrandEnum["CITROEN"] = "citroen";
    BasicBrandEnum["DS"] = "ds";
    BasicBrandEnum["VAUXHALL"] = "vauxhall";
    BasicBrandEnum["OPEL"] = "opel";
})(BasicBrandEnum = exports.BasicBrandEnum || (exports.BasicBrandEnum = {}));
exports.BrandCodeToBasicBrand = {
    [BrandCodeEnum.CITROEN]: BasicBrandEnum.CITROEN,
    [BrandCodeEnum.PEUGEOT]: BasicBrandEnum.PEUGEOT,
    [BrandCodeEnum.DS]: BasicBrandEnum.DS,
    [BrandCodeEnum.DSAUTOMOBILES]: BasicBrandEnum.DS,
    [BrandCodeEnum.VAUXHALL]: BasicBrandEnum.VAUXHALL,
};
exports.BasicBrandToBrandCode = {
    [BasicBrandEnum.CITROEN]: BrandCodeEnum.CITROEN,
    [BasicBrandEnum.PEUGEOT]: BrandCodeEnum.PEUGEOT,
    [BasicBrandEnum.DS]: BrandCodeEnum.DS,
    [BasicBrandEnum.VAUXHALL]: BrandCodeEnum.VAUXHALL,
    [BasicBrandEnum.OPEL]: BrandCodeEnum.OPEL,
};
var EnvNameEnum;
(function (EnvNameEnum) {
    EnvNameEnum["DEV"] = "dev";
    EnvNameEnum["QA"] = "qa";
    EnvNameEnum["PREPROD"] = "preprod";
    EnvNameEnum["PROD"] = "prod";
    EnvNameEnum["GREEN"] = "green";
    EnvNameEnum["BLUE"] = "blue";
})(EnvNameEnum = exports.EnvNameEnum || (exports.EnvNameEnum = {}));
exports.DefaultApiVersions = {
    [ModuleEnum.SPC_API]: 'v1',
    [ModuleEnum.DIGITAL_API]: 'v1',
    [ModuleEnum.FC]: 'v3',
    [ModuleEnum.DEALER]: 'v1',
    [ModuleEnum.PX]: 'v1',
    [ModuleEnum.SSM]: 'v1',
    [ModuleEnum.DEAL]: 'v1',
    [ModuleEnum.BO_API]: 'v1',
    [ModuleEnum.DIGITAL]: 'v1',
    [ModuleEnum.STATIC]: 'v1',
    [ModuleEnum.CAMPAIGN_BUILDER]: 'v1',
    [ModuleEnum.CUSTOMER_JOURNEY]: 'v1',
    [ModuleEnum.EMAIL]: 'v1',
    [ModuleEnum.LEADTIME]: 'v1',
    [ModuleEnum.CONTENT_MANAGER]: 'v1',
    [ModuleEnum.RETAIL_FRONTEND]: 'v1',
    [ModuleEnum.NEOLANE_ADAPTER]: 'v1',
};
